import { notification } from 'antd';
import { API_BASE_URL } from '../config';
import { UploadChangeParam, UploadFile } from 'antd/es/upload';
import { PageBody, PageHead } from '../layout';
import { UploadDropzone } from '../components/ui';

const UploadSwitchList = () => {
  function onChange(info: UploadChangeParam<UploadFile<any>>) {
    if (info.file.status === 'done') {
      notification.success({ message: 'List successfully uploaded.' });
    } else if (info.file.status === 'error') {
      notification.error({ message: 'List failed to upload.' });
    }
  }

  return (
    <>
      <PageHead
        title="Afternic Switch List"
        subtitle="Upload the Afternic switch list file."
      />
      <PageBody>
        <div className="flex flex-col gap-4">
          <p className="text-text-2 text-[12.5px]">Drop a file here.</p>
          <UploadDropzone
            action={API_BASE_URL + '/v1/afternic/uploadSwitchList'}
            onChange={onChange}
          />
        </div>
      </PageBody>
    </>
  );
};

export default UploadSwitchList;
